import _ from 'lodash';
import $ from 'jquery';
import ShowableWidget from 'gears/ui/showable-widget/component';
import scrollParent from 'gears/util/scroll-parent/component';

let _shownTooltips = [];

// Public Class Methods

class Tooltip extends ShowableWidget {

  constructor(target, options) {
    if (options == null) { options = {}; }
    let $target = $(target).first();
    if ($target.length !== 1) {
      throw new Error(`Cannot find element \"${target}\" to create new Tooltip`);
    }
    let self = super(target, options);
    let title = $target.attr("title");
    if (title) {
      if (!self.options.title) { self.options.title = title; }
      $target.removeAttr("title");
      $target.data(self._getNamespace() + ":title", title);
    } else if ($target.data(self._getNamespace() + ":title")) {
      if (!self.options.title) { self.options.title = $target.data(self._getNamespace() + ":title"); }
    }
  }

  show(e) {
    if (!(e instanceof $.Event)) { _shownTooltips.push(this); }
    if (Tooltip.updatePositionOnScroll) {
      this._scrollParents = [];
      let $scrollParent = scrollParent(this.$target);
      while ($scrollParent[0] !== document) {
        this._scrollParents.push($scrollParent);
        $scrollParent = scrollParent($scrollParent);
      }
      this._scrollParents.forEach($el => $el.on(`scroll.${this._getNamespace()}:${this.wid}`, _.bind(this._position, this)));
    }
    return super.show(...arguments);
  }

  hide(e) {
    if (!(e instanceof $.Event)) {
      _shownTooltips = _.without(_shownTooltips, this);
    }
    if (Tooltip.updatePositionOnScroll) {
      if (!this._scrollParents) { this._scrollParents = []; }
      this._scrollParents.forEach($el => $el.off(`scroll.${this._getNamespace()}:${this.wid}`));
    }
    if (!Array.from(_shownTooltips).includes(this)) { return super.hide(...arguments); }
  }

  destroy() {
    _shownTooltips = _.without(_shownTooltips, this);
    __guard__(this.$target, x => x.off(`.${this._getNamespace()}`)
      .removeData(this._getNamespace())
      .removeData(this._getNamespace() + ":title"));
    $(document).off(`.${this._getNamespace()}:${this.wid}`);
    $(window).off(`.${this._getNamespace()}:${this.wid}`);
    return super.destroy(...arguments);
  }

  state() {
    return this._state;
  }

  _initialize() {
    super._initialize(...arguments);
    return this._setEvents();
  }

  _update() {
    if (this.changedOptions.trigger) {
      this._setEvents();
    }
    if (((this._state === "shown") || (this._state === "showing")) && !_.isEmpty(this.changedOptions)) {
      return this._render();
    }
  }

  _render() {
    let adjustedPlacement = this._adjustedPlacement(this.options.placement);
    if (!this.$el) {
      this.$el = $(`\
<div class="${Tooltip.className} ${Tooltip.className}--${adjustedPlacement}">
<div class="${Tooltip.className}__arrow"></div>
<div class="${Tooltip.className}__title">${_.escape(this.options.title)}</div>
</div>\
`);
    } else {
      if (this.changedOptions.title) {
        this.$el.find(`.${Tooltip.className}__title`).text(this.options.title);
      }
      if (this.changedOptions.placement) {
        this.$el
          .removeClass(`${Tooltip.className}--${this.previousOptions.placement}`)
          .addClass(`${Tooltip.className}--${adjustedPlacement}`);
      }
    }

    // only set the max-width style if it"s explicitly set
    if (this.options.maxWidth) { this.$el.css("max-width", this.options.maxWidth); }

    // only call position is this tooltip is currently shown
    if ((this._state === "showing") || (this._state === "shown")) { return this._position(); }
  }

  _adjustedPlacement(placement) {
    if ($(window).width() < 450) {
      if (placement === 'left') {
        return 'top';
      } else if (placement === 'right') {
        return 'bottom';
      } else {
        return placement;
      }
    } else {
      return placement;
    }
  }

  _position() {
    let style = {};
    if (["hidden", "destroyed"].includes(this.state())) { return; }

    let adjustedPlacement = this._adjustedPlacement(this.options.placement);
    switch (adjustedPlacement) {
      case "top":
        style.left = Math.round(this.$target.offset().left + ((this.$target.outerWidth() - this.$el.outerWidth())/2));
        style.top = Math.round(this.$target.offset().top - this.$el.outerHeight());
        break;
      case "right":
        style.left = Math.round(this.$target.offset().left + this.$target.outerWidth());
        style.top = Math.round(this.$target.offset().top - ((this.$el.outerHeight() - this.$target.outerHeight())/2));
        break;
      case "bottom":
        style.left = Math.round(this.$target.offset().left + ((this.$target.outerWidth() - this.$el.outerWidth())/2));
        style.top = Math.round(this.$target.offset().top + this.$target.outerHeight());
        break;
      case "left":
        style.left = Math.round(this.$target.offset().left - this.$el.outerWidth());
        style.top = Math.round(this.$target.offset().top - ((this.$el.outerHeight() - this.$target.outerHeight())/2));
        break;
    }

    // determine if the position should be absolute or static based on the input ancestor"s positions
    let positions = this.$target.parents().map( function() { return $(this).css("position"); });
    if (Array.from(positions).includes("fixed")) {
      style.position = "fixed";
      // if position is fixed and we're scrolled down in the document
      // we need to account for that difference
      style.top -= $(window).scrollTop();
    }

    if (style.left < 15) {
      style.left = 15;
      if (adjustedPlacement === 'left') {
        this.set({placement: 'right'});
        return;
      } else {
        this._hideArrow();
      }
    }

    return this.$el.css(style);
  }

  _hideArrow() {
    return this.$el.find(`.${Tooltip.className}__arrow`).hide();
  }

  _setEvents() {
    this.$target.off(`.${this._getNamespace()}`);
    $(window).on(`resize.${this._getNamespace()}:${this.wid}`, _.debounce(_.bind(this._position, this), 100));

    if (this.previousOptions.trigger === "click") {
      $(document).off(`.${this._getNamespace()}:${this.wid}`);
    }
    if (this.options.trigger === "hover") {
      this.$target.on(`mouseenter.${this._getNamespace()}`, _.bind(this.show, this));
      this.$target.on(`mouseleave.${this._getNamespace()}`, _.bind(this.hide, this));
    }
    if (this.options.trigger === "click") {
      this.$target.on(`click.${this._getNamespace()}`, _.bind(this._toggle, this));
      return $(document).on(`click.${this._getNamespace()}:${this.wid}`, _.bind(this._handleClicksOutside, this));
    }
  }


  // toggle click events for show/hide
  _toggle(e) {
    __guard__(e, x => x.preventDefault());
    if ((this._state === "showing") || (this._state === "shown")) {
      return this.hide(e);
    } else {
      return this.show(e);
    }
  }

  _handleClicksOutside(e) {
    if ((this._state !== 'destroyed') && !((this.$target[0] === e.target) || this.$target.find(e.target).length)) {
      return this.hide(e);
    }
  }
}


Tooltip.defaults = {
  animate: true,
  destroyOnHidden: false,
  // maxWidth: 200 (set via CSS)
  removeOnHidden: true,
  // title: (usually set via the title attribute)
  trigger: "hover",
  placement: "top"
};


Tooltip.className = "tooltip";

Tooltip.namespace = "gears:tooltip";

// Configures whether or not we recalculate the Tooltip's position on scroll
Tooltip.updatePositionOnScroll = false;

export default Tooltip;

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
